export function reportError(e) {
    console.error(e);
    var error = typeof e === 'string' ? new Error(e) : e;
}
